import RenderDateWithFromTime from '@/common-utils/components/renders/date/RenderDateWithFromTime';
import generateColumnDefByField from '@/common-utils/functions/generateColumnDefByField';
import ColumnSelection from '@/common-utils/components/renders/dataTable/column/ColumnSelection';
import historicsFields from '../../../fields/historicsFields';
import DropdownHistoricsActionsRow from '../../dropdown/DropdownHistoricsActionsRow';
import RenderUserInitiator from '../../userInitiator/RenderUserInitiator';
import { Badge } from '@/common-utils/components/ui/badge';
import HISTORICS_OUTCOME_TYPE from '../../../enums/HistoricsOutcomeType';
import Entity from '@/common-utils/components/renders/entity/Entity';
import { nsHistorics } from '@/app/i18n/namespaces';
import RenderHistoricsValue from '../../cells/RenderHistoricsValue';

export const columnsHistorics = (headerPackage) => {
    return ([
        // ColumnSelection
        headerPackage.selectionMode && ColumnSelection(columnsHistoricsId, headerPackage.singleSelection),
        // Columns
        generateColumnDefByField({
            field: historicsFields.COMMON.UUID,
            headerPackage: headerPackage,
            show: !headerPackage.selectionMode,
            customCellFn: ({ row }) => (
                row &&
                <DropdownHistoricsActionsRow
                    historics={row.original}
                    actions={headerPackage.actions}
                />
            )
        }),
        generateColumnDefByField({
            field: historicsFields.COMMON.ACTION_TIMESTAMP,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(historicsFields.COMMON.ACTION_TIMESTAMP.key)} />
            )
        }),
        ...headerPackage.customColumns(headerPackage),
        generateColumnDefByField({
            field: historicsFields.COMMON.ORGANIZATION_LEGAL_NAME,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: { ...historicsFields.COMMON.ACTION_TYPE, enum: headerPackage.actions },
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                const action = headerPackage.actions[cell.getValue(historicsFields.COMMON.ACTION_TYPE.key)];
                return cell &&
                    <Entity entity={action.entity} namespace={nsHistorics} />;
            }
        }),
        generateColumnDefByField({
            field: historicsFields.COMMON.OUTCOME,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                const status = HISTORICS_OUTCOME_TYPE[cell.getValue(historicsFields.COMMON.OUTCOME.key)];
                return (
                    status &&
                    <Badge entity={status.entity} namespace={status.namespace} variant={status.variant} />
                );
            }
        }),
        generateColumnDefByField({
            field: historicsFields.COMMON.USER_EMAIL,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderUserInitiator cellData={cell.getValue(historicsFields.COMMON.USER_EMAIL.key)} />
            )
        }),
        generateColumnDefByField({
            field: historicsFields.COMMON.ATTRIBUTES_VALUES_BEFORE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderHistoricsValue
                    cellData={cell.getValue(historicsFields.COMMON.ATTRIBUTES_VALUES_BEFORE.key)}
                    action={headerPackage.actions[cell.row.original.actionType]}
                />
            )
        }),
        generateColumnDefByField({
            field: historicsFields.COMMON.ATTRIBUTES_VALUES_AFTER,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderHistoricsValue
                    cellDataBefore={cell.row.original.attributesValuesBefore}
                    cellData={cell.getValue(historicsFields.COMMON.ATTRIBUTES_VALUES_AFTER.key)}
                    action={headerPackage.actions[cell.row.original.actionType]}
                />
            )
        })
    ]).filter(col => !!col);
};